import { decodeURIComponentSafe } from 'helpers/BrowserHelpers';

import { getCommonListingPageSeoProps, getOpenGraphUrl, getPageSeoBreadcrumbs } from './SeoHelpers';

import type { ICustomListingPageUrlParams, PageSeoProps, TFunction } from 'types';

export function getCustomListingPageSeoProps(
  t: TFunction,
  urlParams: ICustomListingPageUrlParams,
  name?: string,
): PageSeoProps {
  const decodedName = decodeURIComponentSafe(name);
  return {
    seoProps: {
      ...getCommonListingPageSeoProps(urlParams),
      title: decodedName,
      description: `${t('SEO.CUSTOM_LISTING.DESCRIPTION')}`,
      openGraph: {
        url: getOpenGraphUrl(),
        description: `${t('SEO.CUSTOM_LISTING.DESCRIPTION')}`
      },
    },
    breadcrumbs: getPageSeoBreadcrumbs(t)
  };
}
